// ColoredSnackbar.jsx
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function ColoredSnackbar({
  open,
  onClose,
  message,
  severity = "info",
  autoHide = 4000,
  anchorOrigin = { vertical: "bottom", horizontal: "right" },
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHide}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        elevation={6}
        variant="filled"
        onClose={onClose}
        severity={severity}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
